import * as React from 'react';
const DarkFish = ({ style = {}, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={25}
    height={11}
    fill='none'
    style={{...style }}
    {...props}
  >
    <g clipPath='url(#bluefishA)'>
      <path
        fill='currentColor'
        d='M24.895 5.868c-3.754 5.963-15.982 6.935-21.6 1.832L1.432 9.288a.344.344 0 0 1-.529-.103l-.88-1.733a.2.2 0 0 1-.016-.14.172.172 0 0 1 .041-.073l1.592-1.73.006.005v-.009l-.006.005L.047 3.78a.172.172 0 0 1-.04-.072.2.2 0 0 1 .015-.14l.88-1.734c.1-.196.36-.247.529-.104l1.854 1.58c5.612-5.114 17.854-4.144 21.61 1.822a.7.7 0 0 1 0 .736Z'
      />
      <path
        fill='#fff'
        d='M19.323 4.96c.651 0 1.18-.516 1.18-1.154 0-.637-.529-1.153-1.18-1.153-.652 0-1.18.516-1.18 1.153 0 .638.528 1.154 1.18 1.154Z'
      />
    </g>
    <defs>
      <clipPath id='bluefishA'>
        <path fill='#fff' d='M0 0h25v11H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default DarkFish;
